export default "__VITE_ASSET__CfWR7UdD__"